/**
 * Latori: keeps the cart's "+N Bonuspunkte" figures (cart drawer line in
 * snippets/cart-loyalty-latori.liquid, summary row in
 * snippets/cart-summary-latori.liquid) in sync with Rivo's live program
 * config instead of the Liquid-rendered fallback constants.
 *
 * Both figures render as `<span data-loyalty-points data-cart-total="<cents>"
 * data-tier="bronze|silver|gold" data-customer="0|1">N</span>` inside
 * `[data-merge]` regions that theme.mergeNodes() replaces on every cart
 * change - so this is not a custom element bound to one node but a document
 * level MutationObserver that re-applies to whatever spans currently exist.
 * It only writes when the text actually differs, which is what keeps the
 * observer from feeding itself (same guard as cart-shipping-estimate-latori).
 *
 * Value precedence per span:
 *   1. logged-in customer: RivoAPI.cart_earnings_estimation() for the current
 *      /cart.js payload - Rivo's own number, including excluded products,
 *      collections, order tags and gift cards;
 *   2. rivoConfigLatori.points(total, tier) - Rivo's rate + rounding rule;
 *   3. leave the server-rendered fallback alone.
 */
(function () {
  if (window.cartLoyaltyPointsLatori) return;

  var SELECTOR = '[data-loyalty-points]';
  var scheduled = null;
  var running = false;
  var rerun = false;

  function spans() {
    return Array.prototype.slice.call(document.querySelectorAll(SELECTOR));
  }

  function write(el, value) {
    var text = window.rivoConfigLatori ? window.rivoConfigLatori.formatPoints(value) : String(value);
    if (el.textContent !== text) el.textContent = text;
  }

  function fetchCart() {
    var base = (window.theme && theme.routes && theme.routes.cart) || '/cart';
    return fetch(base + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .catch(function () {
        return null;
      });
  }

  function update() {
    var cfg = window.rivoConfigLatori;
    var nodes = spans();
    if (!cfg || !nodes.length) return Promise.resolve();

    var loggedIn = nodes.some(function (el) {
      return el.dataset.customer === '1';
    });

    var estimation = loggedIn
      ? fetchCart().then(function (cart) {
          return cart ? cfg.estimateCart(cart) : null;
        })
      : Promise.resolve(null);

    return estimation.then(function (estimated) {
      spans().forEach(function (el) {
        var value = null;
        if (el.dataset.customer === '1' && estimated !== null && estimated !== undefined) {
          value = estimated;
        } else {
          value = cfg.points(el.dataset.cartTotal, el.dataset.tier);
        }
        if (value !== null && value !== undefined) write(el, value);
      });
    });
  }

  function run() {
    if (running) {
      rerun = true;
      return;
    }
    running = true;
    update().then(function () {
      running = false;
      if (rerun) {
        rerun = false;
        schedule();
      }
    });
  }

  function schedule() {
    if (scheduled) clearTimeout(scheduled);
    scheduled = setTimeout(function () {
      scheduled = null;
      run();
    }, 150);
  }

  function init() {
    if (!window.rivoConfigLatori) return;
    window.rivoConfigLatori.ready(function (config) {
      if (!config) return; // Rivo never loaded - keep the server-rendered values
      run();
      new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var added = mutations[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var node = added[j];
            if (node.nodeType !== 1) continue;
            if (node.matches(SELECTOR) || node.querySelector(SELECTOR)) {
              schedule();
              return;
            }
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
      document.addEventListener('on:cart:change', schedule);
      document.addEventListener('on:cart:add', schedule);
    });
  }

  window.cartLoyaltyPointsLatori = { update: run };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
